module.exports = __webpack_public_path__ + "static/TMD 2 Intraoral after-1677a0c7156339fe98b11b2bd21d18ab.jpg";